// 加盟店申請(直接)アップロード画面のラベル
export const LABELS = {
  APPLICATION_TARGET_SERVICE: "申請対象サービス",
  APPLICATION_FILE: "申請ファイル",
  FILE_PLACEHOLDER: "アップロード対象ファイル",
  NO: "No",
  ERROR_DETAIL: "エラー内容",
  ERROR_TITLE: "提出ファイルエラー内容",
  ERROR_TEXT_LABEL: "まだファイルはアップロードされていません。",
  MAINTENANCE_LABEL: "メンテナンス",
  CANCELLATION: "解約",
} as const;

export const CONFIGS = {
  FILE: "file",
  FILE_EXTENSION: ".xlsx",
  UPLOAD_TYPE: "uploadType",
  ALTERNATIVE_DIRECT_APPLY: "申請ファイル",
  SUCCESS: "success",
  SELECT_ITEM: "selectItem",
  MAINTENANCE_FLG: "maintenanceFlg",
} as const;

export const CONTENTS = {
  ALTERNATIVE_DIRECT: "\r\n・申請ファイル\r\n　　ファイル名：{0}",
} as const;

export const CANCEL_NOTICE = "サイトIDの解約申請が含まれています。";
export const CANCEL_NOTICE_CONTENT =
  "\r\n　こちらのサイトIDに紐付く店舗が営業中の場合は、自動で閉店処理を実施します\r\n";

export const UPDATE_DIFFERENCIAL_INFO = {
  SHEET_NAME: "提出用",
  ROW_NO: 5,
  COL_NO: 4,
};
